// extracted by mini-css-extract-plugin
module.exports = {"Link":"link_Link__Df8SF","Link__icon":"link_Link__icon__LZcsg"};